import React from "react";
import { BiCollection, BiHash } from "react-icons/bi";

const CustomBadge = ({ title, length }) => {
  return (
    <div
      className={
        "fs-14 mb-3 d-flex justify-content-center align-items-center mx-2 border-0 bg-white border-primary rounded text-black px-3 py-2 fw-semibold shadow-sm gap-2"
      }
    >
      <BiCollection size={18} />
      {`${title} - ${length ?? 0}`}
    </div>
  );
};

export default CustomBadge;
